// src/features/mech/plastics/questions/BatchSizeQuestion.jsx
import React, { useState } from "react";
import { Box } from "@mui/material";
import { alpha, useTheme } from "@mui/material/styles";
import PerlTextField from "../../../../shared/components/PerlTextField";

const calculateVolumeCategory = (batchSizeValue) => {
  if (!/^[+]?(?:[0-9]+(?:\.[0-9]*)?|\.[0-9]+)(?:e[+-]?[0-9]+)?$/i.test(String(batchSizeValue).trim())) return "";
  const count = Number(batchSizeValue);
  if (!Number.isSafeInteger(count) || count <= 0) return "";
  const annualVolume = count * 12;
  if (annualVolume <= 500) return "Low Volume <=500";
  if (annualVolume <= 1000) return "Low Volume >500 to <=1,000";
  if (annualVolume <= 5000) return "Low Volume >1,000 to <=5,000";
  if (annualVolume <= 20000) return "Low Volume >5,000 to <=20,000";
  if (annualVolume <= 100000) return "Medium Volume >20,000 to <=100,000";
  return "High Volume >100,000";
};

export default function BatchSizeQuestion({ value, onChange }) {
  const theme = useTheme();
  const perlColors = theme.custom?.perlColors || {
    white: "#ffffff",
    textPrimary: "#F1F2F3",
    textSecondary: "#9097A1",
  };
  const brandColor =
    theme.custom?.perlColors?.brandColor || theme.palette?.primary?.main || "#ff6034";

  const batchSize = value || "";
  const volumeCategory = calculateVolumeCategory(batchSize);
  const [isFocused, setIsFocused] = useState(false);

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 2, pt: 1 }}>
      <PerlTextField
        label="Enter Batch size"
        type="number"
        value={batchSize}
        onChange={(e) => onChange?.(e.target.value)}
        placeholder="Enter batch size"
        variant="outlined"
        sx={{ mt: 1.5 }}
        onFocus={() => setIsFocused(true)}
        onBlur={() => setIsFocused(false)}
        InputProps={{
          sx: {
            bgcolor: alpha(perlColors.white, 0.02),
            color: perlColors.textPrimary,
            fontSize: "0.9rem",
            borderRadius: 1.5,
            "& fieldset": { borderColor: alpha(perlColors.textPrimary, 0.12) },
            "&:hover fieldset": { borderColor: alpha(brandColor, 0.8) },
            "&.Mui-focused fieldset": {
              borderColor: brandColor,
              boxShadow: `0 0 0 2px ${brandColor}33`,
            },
          },
        }}
        InputLabelProps={{
          shrink: isFocused || !!batchSize,
          sx: {
            color: perlColors.textSecondary,
            fontSize: "0.85rem",
            letterSpacing: "0.3px",
            "&.Mui-focused": { 
              color: perlColors.textPrimary,
            },
            "&.MuiInputLabel-shrink": {
              color: perlColors.textPrimary,
            },
          },
        }}
      />
      <PerlTextField
        label="Volume Category"
        helperText="Annual volume basis: batch size x 12."
        value={volumeCategory || ""}
        placeholder="Volume category will be calculated"
        disabled
        InputProps={{
          sx: {
            bgcolor: alpha(perlColors.white, 0.02),
            color: perlColors.textPrimary,
            fontSize: "0.9rem",
            borderRadius: 1.5,
            "& fieldset": { borderColor: alpha(perlColors.textPrimary, 0.12) },
            "&.Mui-disabled": {
              bgcolor: alpha(perlColors.white, 0.04),
              color: perlColors.textPrimary,
            },
          },
        }}
        InputLabelProps={{
          sx: {
            color: perlColors.textSecondary,
            fontSize: "0.85rem",
            letterSpacing: "0.3px",
          },
        }}
      />
    </Box>
  );
}

